export const ERRORS = {
  // Deck Sizes
  SIDEBOARD_SIZE: `A deck's sideboard can have no more than 15 cards.`,

  // Size
  SINGLETON: 'You may only have one copy of a card in a singleton format -',
  MAX_COUNT: 'You may only have four of any one card -',

  BANNED: 'This card is banned in this format -',
  NOT_LEGAL: 'This card is not legal in this format -',
  PRERELEASED_CARD_EDH: 'This card is not "technically" legal until its official prerelease date',

  // Commander
  REQUIRE_COMMANDER: 'An EDH deck must have a Commander.',
  CREATURE_COMMANDER: 'This card may not be your commander.',
  LEGENDARY_COMMANDER: 'Your commander must be a legendary.',
  PARTNER_COMMANDERS: 'Only partner commanders can be paired together',
  PARTNER_WITH_COMMANDERS: '"Partner with" commanders must be partnered with their partner.',
  SINGLE_COMMANDER: 'Max of one Commander (Two if they both have Partner).',
  OUTSIDE_COLOR_IDENTITY: "You have a card outside of your commander's color identity -",
  BANNED_AS_COMPANION: 'This card is banned as a companion -',
  ADITIONAL_COLOR_COMMANDER:
    'Your commander can only add one extra color to the total identity of the deck. It looks like you have more than one color outside your provided color identity',
  MOVE_TO_COMPANION:
    'You have incorrectly set your comapanion as a commander. Use the "Set companion" button to correctly set your companion for this deck -',

  // Brawl
  REQUIRE_BRAWL_COMMANDER: 'In Brawl, your commander must be a Creature or a Planeswalker.',
  SINGLE_BRAWL_COMMANDER: 'You may only have one commander.',

  // Vintage
  RESTRICTED: 'You may only have one copy of the card in your deck -',

  // Oathbreaker
  SINGLE_OATHBREAKER: 'You may only have one Oathbreaker (usually) -',
  SINGLE_SIGNATURE_SPELL: 'You may only have one Siganture Spell (usually) -',
  PARTNER_OATHBREAKERS: 'Only partner oathbreakers can be paired together',
  PARTNER_SIGNATURE_SPELL: 'Each Partner must have their own signature spell -',

  // 1v1 Commander
  BANNED_AS_COMMANDER: 'This card is banned as a commander -',

  // Pauper EDH
  VALID_PAUPER_COMMANDER: 'This card is not a valid commander is Pauper EDH. It must be a creature and uncommon -',
  NO_UNCOMMONS_IN_99: 'An uncommon creature may only be used in Pauper EDH if it is your commander -',

  // Companion:
  UNKNOWN_COMPANION: "Unknown companion! We're skipping the legality check for this companion -",
  COMPANION_ERROR: 'Companion conditions not met for ',
  MULTIPLE_COMPANIONS: 'A deck may only contain one set companion, checking last found companion for legality',

  // Canlander
  OVER_MAX_POINTS_CANLANDER: 'Canadian Highlander decks may only have a maximum of up to 10 points.',

  // Tiny Leaders Reborn
  REQUIRE_TLR_COMMANDER: 'Tiny Leaders Reborn decks must have a commander',
  TLR_SIDEBOARD_SIZE: 'Tiny Leaders Reborn decks may have a maximum of 10 cards in their sideboards',

  // EDH Brackets
  NO_GAME_CHANGERS: 'Commander Bracket mis-match: You may not have any game changers in your deck -',
  NO_MASS_LAND_DENIAL: 'Commander Bracket mis-match: You may not have any mass land denial in your deck -',
  TOO_MANY_NON_LAND_TUTORS: 'Commander Bracket mis-match: You may only have a "few" non-land tutors in your deck -',
  TOO_MANY_GAME_CHANGERS:
    'Commander Bracket mis-match: You may only have up to three game changer cards in your deck -',
  NO_TWO_CARD_INF_COMBOS: 'Commander Bracket mis-match: You may not have any two card infinite combos in your deck -',
  NO_EXTRA_TURNS: 'Commander Bracket mis-match: You may not have any extra turn cards in your deck -',

  // Random user mis-use
  COMMANDER_CATEGORY_NOT_PREMIER:
    'You Commander category is lacking the "Premier" flag that denotes it as a "Commander" category. A handful of features will not work without a dedicated commander category. Either edit your Commander category to enable the "Premier" flag, or change this category name from Commander to something else if you wish to remain without a commander -',

  // Rulebreakers
  TOLABOW: 'Your commander only allows instants and sorceries of a single additional color - ',
}

export const CARD_QTY_OVERRIDE: Record<string, number> = {
  'Seven Dwarves': 7,
  'Nazgûl': 9,
  Plains: -1,
  Island: -1,
  Swamp: -1,
  Mountain: -1,
  Forest: -1,
  Wastes: -1,
  'Snow-Covered Plains': -1,
  'Snow-Covered Island': -1,
  'Snow-Covered Swamp': -1,
  'Snow-Covered Mountain': -1,
  'Snow-Covered Forest': -1,
  'Snow-Covered Wastes': -1,
  'Relentless Rats': -1,
  'Rat Colony': -1,
  'Shadowborn Apostle': -1,
  'Persistent Petitioners': -1,
  "Dragon's Approach": -1,
  'Slime Against Humanity': -1,
  'Templar Knight': -1,
  'Hare Apparent': -1,
  'Tempest Hawk': -1,
  'Cid, Timeless Artificer': -1,
}

export const COMMANDER_OVERRIDE = ['Grist, the Hunger Tide']
